<template>
    <div class="lamptip" :class="{ visible: visible }">
        <a href="javascript:;" class="lamptip-trigger" @click="onToggle">
            <v-icon name="lamp"></v-icon>
        </a>
        <div v-show="visible" class="lamptip-arrow"></div>
        <div class="lamptip-content" :class="{ visible: visible }" :style="contentStyle">
            <div class="lamptip-wrapper">
                <div class="lamptip-animate">
                    <a href="javascript:;" class="lamptip-close" @click="onClose"></a>
                    <slot></slot>
                    <!-- 书写样例格式，内置了一些样式
                    <div class="lamptip-desc">
                        <p>XXXXXX</p>
                    </div>
                    <div class="lamptip-divider"></div>
                    <div class="lamptip-list">
                        <div class="lamptip-item">
                            <span class="lamptip-label">XXXXXX</span>
                            <a href="XXXXXX">XXXXXX</a>
                        </div>
                    </div>
                    -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'LampTip',

    props: {
        localKey: {
            type: String,
            default: ''
        },
        cache: {
            type: Boolean,
            default: true
        },
        customStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        isLoadShow: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            visible: false
        };
    },

    computed: {
        contentStyle() {
            if (this.visible) {
                return this.customStyle;
            }
            return {};
        }
    },

    created() {
        const { localKey } = this;
        // 检查 window.kf 是否存在，并安全地访问 uin 属性
        const uin = window.kf && window.kf.uin;
        if (!window.localStorage[`${localKey}_${uin}`]) {
            this.visible = true;
        }
        if (this.isLoadShow) {
            this.visible = true;
        }
    },

    methods: {
        onToggle() {
            this.visible = !this.visible;

            if (!this.visible && this.cache) {
                const { localKey } = this;
                const uin = window.kf && window.kf.uin;
                if (!window.localStorage[`${localKey}_${uin}`]) {
                    window.localStorage[`${localKey}_${uin}`] = 1;
                }
            }
        },

        onClose() {
            this.visible = false;
            if (!this.cache) return;
            const { localKey } = this;
            const uin = window.kf && window.kf.uin;
            if (!window.localStorage[`${localKey}_${uin}`]) {
                window.localStorage[`${localKey}_${uin}`] = 1;
            }
        }
    }
};
</script>

<style lang="less">
.lamptip {
    position: relative;
    margin-top: 5px;

    &__content {
        font-size: 14px;
        line-height: 22px;
    }
}

.lamptip-trigger {
    position: absolute;
    top: -43px;
    right: 0;
    color: #ffb636;

    svg {
        width: 30px;
        height: 30px;
    }

    &:hover {
        color: #ffa623;
    }
}

.lamptip-wrapper {
    position: relative;
    padding: 22px 24px 18px;
    background-color: #fff9ee;
    border-radius: 3px;

    .lamptip-close {
        position: absolute;
        top: 10px;
        right: 10px;
        display: block;
        width: 10px;
        height: 10px;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjEwcHgiIHZpZXdCb3g9IjAgMCAyMDAgMjEwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9IiNGRkI2MzYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTQuOTk2NDcxODQsMy41NTY4NzgwMyBMOC4zNTM2NjA5OCwwLjE5ODk3MjM2NyBDOC42MjE0NTI4OSwtMC4wNjYzMjQxMjIyIDkuMDUyOTYwNiwtMC4wNjYzMjQxMjIyIDkuMzIwNzUyNTEsMC4xOTg5NzIzNjcgTDkuNzk5NjkzMDcsMC42Nzg4ODIyMiBDOS45Mjc4ODA5OSwwLjgwNTg1ODk5NSAxMCwwLjk3ODgxMjc2MSAxMCwxLjE1OTI1MjY0IEMxMCwxLjMzOTY5MjUyIDkuOTI3ODgwOTksMS41MTI2NDYyOCA5Ljc5OTY5MzA3LDEuNjM5NjIzMDYgTDYuNDM5NjU5NTMsNS4wMDAzNzM3MyBMOS43OTk2OTMwNyw4LjM2MTEyNDQgQzkuOTI3ODgwOTksOC40ODgxMDExNyAxMCw4LjY2MTA1NDk0IDEwLDguODQxNDk0ODIgQzEwLDkuMDIxOTM0NyA5LjkyNzg4MDk5LDkuMTk0ODg4NDYgOS43OTk2OTMwNyw5LjMyMTg2NTI0IEw5LjMyMDc1MjUxLDkuODAxNzc1MDkgQzkuMDUyNTUxMzYsMTAuMDY2MDc1IDguNjIxODYyMTMsMTAuMDY2MDc1IDguMzUzNjYwOTgsOS44MDE3NzUwOSBMNC45OTY0NzE4NCw2LjQ0Mzg2OTQzIEwxLjYzOTI4MjcsOS44MDE3NzUwOSBDMS4zNzEwODE1NiwxMC4wNjYwNzUgMC45NDAzOTIzMjcsMTAuMDY2MDc1IDAuNjcyMTkxMTgzLDkuODAxNzc1MDkgTDAuMTkzMjUwNjIsOS4zMjE4NjUyNCBDLTAuMDY0NDE2ODczNCw5LjA1MzQ1Nzg5IC0wLjA2NDQxNjg3MzQsOC42Mjk1MzE3NSAwLjE5MzI1MDYyLDguMzYxMTI0NCBMMy41NTMyODQxNiw1LjAwMDM3MzczIEwwLjE5MzI1MDYyLDEuNjM5NjIzMDYgQy0wLjA2NDQxNjg3MzQsMS4zNzEyMTU3MSAtMC4wNjQ0MTY4NzM0LDAuOTQ3Mjg5NTcgMC4xOTMyNTA2MiwwLjY3ODg4MjIyIEwwLjY3MjE5MTE4MywwLjE5ODk3MjM2NyBDMC45Mzk5ODMwODgsLTAuMDY2MzI0MTIyMiAxLjM3MTQ5MDgsLTAuMDY2MzI0MTIyMiAxLjYzOTI4MjcsMC4xOTg5NzIzNjcgTDQuOTk2NDcxODQsMy41NTY4NzgwMyBaIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==');
    }

    .lamptip-desc {
        font-size: 14px;
        line-height: 22px;
    }

    .lamptip-divider {
        margin: 10px 0;
        height: 1px;
        background-color: #fddfab;
        opacity: 0.6;
    }

    .lamptip-list {
        font-size: 12px;
    }

    .lamptip-item {
        line-height: 18px;
        margin-bottom: 5px;
        color: #66686c;
    }

    .lamptip-label {
        display: inline-block;
        margin-right: 15px;
        font-weight: 500;
        color: #66686c;
        font-style: italic;

        &::before {
            display: inline-block;
            margin-right: 3px;
            width: 7px;
            height: 9px;
            content: '';
            background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iN3B4IiBoZWlnaHQ9IjlweCIgdmlld0JveD0iMCAwIDcgOSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTIuMiAoNjcxNDUpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPuefqeW9ouWkh+S7vTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSLlsI/nga/ms6EiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9IjAuODAwMDAwMDEyIj4KICAgICAgICA8ZyBpZD0iMDLlsI/nga/ms6Et5paw5bu65o6l5b6F5YiG57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzA0LjAwMDAwMCwgLTI5My4wMDAwMDApIiBmaWxsPSIjMUUyMzMwIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjgwLjAwMDAwMCwgMTc2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC4wMDAwMDAsIDExMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0i55+p5b2i5aSH5Lu9IiBwb2ludHM9IjMgNCA3IDQgNCAxMyAwIDEzIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==');
        }
    }
}

.lamptip-arrow {
    position: absolute;
    top: -16px;
    right: 8px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    content: '';
    border-bottom: 8px solid #fff9ee;
}
.lamptip-content {
    position: relative;
    overflow: hidden;
    height: 0;
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.63, 0, 0.42, 1);

    &::before {
        // 因为外层容器设置了 overflow: hidden;（大约是为了修复收缩动画造成的问题），这个箭头显示不出来了，所以要重新搞一下。
        // 以防万一，把这个隐藏了
        // position: absolute;
        // top: -16px;
        // right: 8px;
        // width: 0;
        // height: 0;
        // border: 8px solid transparent;
        // content: '';
        // border-bottom: 8px solid #fff9ee;
    }

    .lamptip-wrapper {
        overflow: hidden;

        .lamptip-animate {
            margin-top: -24px;
            transition: all 0.3s cubic-bezier(0.63, 0, 0.42, 1);
        }
    }

    &.visible {
        height: auto;
        opacity: 1;

        .lamptip-wrapper {
            .lamptip-animate {
                margin-top: 0;
            }
        }
    }
}
</style>
